import { useParams } from 'react-router-dom';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import { defaultToEmptyString } from '@dealstack/shared/lib/format/string.ts';
import { useMasterDocumentsScope } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/MasterDocumentsScopeContext.tsx';

export const useMasterDocumentsEndpoints = () => {
	const { organizationId } = useMasterDocumentsScope();
	const { dealId, mipId } = useParams();

	if (organizationId) {
		const params = { organizationId };

		return {
			byId: (templateId: string) =>
				formatUnicorn(
					API_PATHS.PROGRAMME_DEFAULTS_MASTER_DOCUMENTS_ORGANIZATIONID_TEMPLATEID_GET,
					{ ...params, templateId }
				),
			archive: (templateId: string) =>
				formatUnicorn(
					API_PATHS.PROGRAMME_DEFAULTS_MASTER_DOCUMENTS_ORGANIZATIONID_TEMPLATEID_ARCHIVE_PUT,
					{ ...params, templateId }
				),
			list: formatUnicorn(
				API_PATHS.PROGRAMME_DEFAULTS_MASTER_DOCUMENTS_ORGANIZATIONID_LIST_GET,
				params
			),
			create: formatUnicorn(
				API_PATHS.PROGRAMME_DEFAULTS_MASTER_DOCUMENTS_ORGANIZATIONID_POST,
				params
			),
			bulkArchive: formatUnicorn(
				API_PATHS.PROGRAMME_DEFAULTS_MASTER_DOCUMENTS_ORGANIZATIONID_BULK_ARCHIVE_POST,
				params
			),
			bulkDelete: formatUnicorn(
				API_PATHS.PROGRAMME_DEFAULTS_MASTER_DOCUMENTS_ORGANIZATIONID_BULK_DELETE_POST,
				params
			),
		};
	}

	const params = {
		dealId: defaultToEmptyString(dealId),
		programmeId: defaultToEmptyString(mipId),
	};

	return {
		byId: (templateId: string) =>
			formatUnicorn(
				API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_MASTER_DOCUMENTS_TEMPLATEID_GET,
				{ ...params, templateId }
			),
		archive: (templateId: string) =>
			formatUnicorn(
				API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_MASTER_DOCUMENTS_TEMPLATEID_ARCHIVE_PUT,
				{ ...params, templateId }
			),
		list: formatUnicorn(
			API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_MASTER_DOCUMENTS_LIST_GET,
			params
		),
		create: formatUnicorn(
			API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_MASTER_DOCUMENTS_POST,
			params
		),
		bulkArchive: formatUnicorn(
			API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_MASTER_DOCUMENTS_BULK_ARCHIVE_POST,
			params
		),
		bulkDelete: formatUnicorn(
			API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_MASTER_DOCUMENTS_BULK_DELETE_POST,
			params
		),
	};
};
